<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div
    :id="id"
    class="modal"
    :class="className">
    <div
      class="modal-dialog modal-md"
      role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ capitalize(isForSingleCreative ? $t('actions.rejectCreative') : $t('actions.rejectCreatives')) }}
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="cancel">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form class="form-horizontal">
            <p v-if="!needsComment">
              {{ capitalize($t('messages.confirmRejectCreativeFiles')) }}
              {{ isFromDealDetailsView && capitalize($t('messages.rejectExternalCreativesWarning')) }}
            </p>
            <template v-else>
              <p>{{ capitalize($t('names.comment', { n: 2 })) }}</p>
              <textarea
                id="reject_creative_comment"
                v-model="comment"
                name="comments"
                cols="30"
                rows="10"
                class="form-control" />
              <span
                v-if="isCommentTooShort"
                class="help is-danger"
                >{{ $t('messages.pleaseProvideAMeaningfulRejectionComment') }}</span
              >
            </template>
          </form>
        </div>
        <div class="modal-footer">
          <button
            id="reject_creative_btn"
            type="button"
            class="btn btn-primary"
            @click="confirm">
            {{ $t('actions.reject') }}
          </button>
          <button
            type="button"
            class="btn btn-default"
            data-dismiss="modal"
            @click="cancel">
            {{ $t('actions.cancel') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import { capitalize } from 'vue';

  export default {
    components: {},
    props: {
      id: {
        type: String,
      },
      visible: {
        type: Boolean,
        default: false,
      },
      isForSingleCreative: {
        type: Boolean,
        default: true,
      },
      isFromDealDetailsView: {
        type: Boolean,
        default: false,
      },
      needsComment: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        comment: '',
        isCommentTooShort: false,
      };
    },
    computed: {
      className() {
        if (this.visible) {
          return 'visible';
        }
        return 'fade';
      },
    },
    watch: {
      visible() {
        this.isCommentTooShort = false;
      },
    },
    methods: {
      capitalize(x) {
        return capitalize(x);
      },
      confirm() {
        this.isCommentTooShort = false;
        if (this.needsComment && this.comment.trim().length < 10) {
          this.isCommentTooShort = true;
        } else {
          this.$emit('confirmed', this.comment);
        }
      },
      cancel() {
        this.$emit('cancelled');
      },
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  svg {
    position: relative;
    top: 0.3rem;
    width: 2rem;
    height: 2rem;
    margin-right: 0.4rem;
  }
</style>
